module.exports = __webpack_public_path__ + "img/platinum.c7a689d7.svg";